export default __webpack_public_path__ + "static/media/background-top-left.cb6c5bcc.png";